import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=1314f7fe&scoped=true&lang=pug"
import script from "./GenericCard.vue?vue&type=script&lang=js"
export * from "./GenericCard.vue?vue&type=script&lang=js"
import style0 from "./GenericCard.vue?vue&type=style&index=0&id=1314f7fe&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1314f7fe",
  null
  
)

export default component.exports